export const PROBLEMS_TODO = 0
export const PROBLEMS_ONGOING = 1
export const PROBLEMS_CLOSE = 2

export const PRIORITY_LOW = 0
export const PRIORITY_MEDIUM = 1
export const PRIORITY_HIGH = 2

export const JUST_DO_IT = 0
export const SHORT_LOOP = 1
export const QC_STORY = 2

export const PROBLEM_DESCRIPTION_MAX_LENGTH = 450
export const COMMENT_MAX_LENGTH = 600

export const PROBLEM_TABS = {
  description: 0,
  containment_actions: 1,
  rootCauses: 2,
  evidences: 3,
  customer_protection: 4,
  problemIdentification: 5,
  analysis: 6,
  action_plan: 7,
  actionPlanEfficiency: 8,
  efficiency: 9,
}
export const ROOT_CAUSE_SOURCE = {
  fiveWhys: 0,
  detection: 1,
  occurence: 2,
}

export const ACTION_PLAN_EFFICIENCY_TYPES = {
  generic: 0,
  checks: 1,
  efficiency_kpi: 2,
}

export const PROBLEM_NECESSARY_ESCALATE = {
  no: 0,
  yes: 1,
}

export const PRESENTED = 1
export const EXPIRED = 2
export const PLANNED = 3

export const ANALYSIS_TOOL_5WHYS = '5WHYS'
export const ANALYSIS_TOOL_4M = '4M'
export const ANALYSIS_TOOL_5M = '5M'
export const ANALYSIS_TOOL_6M = '6M'
export const ANALYSIS_TOOL_CAUSETOOL = 'CAUSETOOL'
export const SOURCE_MTOOL = 'mtool'
export const SOURCE_SIXMTOOL = 'sixmtool'

export const DEFAULT_CUSTOMER_PROTECTION = {
  prevention_system: false,
  prevention_system_text: '',
  has_worked: false,
  has_worked_text: '',
  description: '',
  actions: [],
  default: true,
}

export const PROBLEM_SOLVING_COLOR = 'purple darken-2'

export const PROBLEM_RESOLUTION_SOURCE = 'problemsolving'

export const PROBLEM_RESOLUTION = 'problem-solving'
export const ROOT_CAUSES_PROBLEM_RESOLUTION = 'root-causes'

export const DETAIL_TYPES = Object.freeze({
  text: 0,
  bool: 1,
  choice: 2,
  date: 3,
  people: 4,
})

export const HAS_IMPACT = 0
export const HAS_NO_IMPACT = 1
export const HAS_PARTIAL_IMPACT = 2

export const EFFICIENCY_TYPES = {
  default: 0,
  checks: 1,
  kpi: 2,
}

export const getEfficiencyFixedIndicator = (problemID) => {
  return {
    name: 'problem_solving.messages.number_implemented_actions',
    problem: problemID,
  }
}


const RANGE_RULE = 0
const GREATER_THAN_RULE = 1
const LESS_THAN_RULE = 2
const OK_NOK = 3
export const EFFICIENCY_KPI_ACHIEVE_RULES = {
  RANGE_RULE: RANGE_RULE,
  GREATER_THAN_RULE: GREATER_THAN_RULE,
  LESS_THAN_RULE: LESS_THAN_RULE,
  OK_NOK: OK_NOK,
}
